// extracted by mini-css-extract-plugin
export var explainable = "_h2-0";